<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold primary--text pa-3 d-md-flex align-center" width="100%">
      <div class="title primery--text">Preferencias del sistema</div>
    </div>

    <v-flex xs12>
      <v-row justify="center">
        <v-col md="8">
          <v-row>
            <v-col cols="12">
              <v-card flat tile>
                <v-card-title>
                  <v-row>
                    <v-col>
                      Idioma
                    </v-col>
                    <v-col class="d-flex justify-end">
                      <v-btn
                        rounded
                        small
                        depressed
                        color="primary"
                        :disabled="!form.languageSection.language"
                        @click="submit">
                        Guardar datos de idioma
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                    <v-row>
                      <v-col cols="6">
                        <v-select
                          label="Idiomas"
                          :items="languages"
                          item-text="text"
                          item-value="value"
                          v-model="form.languageSection.language"
                          return-object
                        />
                      </v-col>
                    </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-flex>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  </v-layout>
</template>

<script>
import i18n from '@/lang'
export default {
  name: 'Restaurant',
  data () {
    return {
      section: 'Configuración',
      overlay: false,
      taxInformationFormValid: false,
      languages: [
        {
          text: 'Español',
          value: 'es'
        },
        {
          text: 'Inglés',
          value: 'en'
        }
      ],
      form: {
        languageSection: {
          language: ''
        }
      }
    }
  },
  computed: {
    restaurantId: function () { return this.$store.state.currentRestaurant.data._id || null },
    providerId: function () { return this.$store.state.currentProvider.data._id || null }
  },
  methods: {
    async submit () {
      this.overlay = true
      try {
        if (!this.$store.state.userProvider) {
          await this.$api.put(`/v1/restaurants/${this.restaurantId}/users/${this.$store.state.login.user._id}`, { language: this.form.languageSection.language.value })
          this.$toasted.show('Se ha actualizado la preferencia de idioma', { duration: 3000 })
          i18n.locale = this.form.languageSection.language.value
        } else {
          await this.$api.put(`/v1/providers/${this.providerId}/users/${this.$store.state.login.user._id}`, { language: this.form.languageSection.language.value, role: 'provider' })
          this.$toasted.show('Se ha actualizado la preferencia de idioma', { duration: 3000 })
          i18n.locale = this.form.languageSection.language.value
        }
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    }
  }
}
</script>
